import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=24e18aae&scoped=true&"
import script from "./Logs.vue?vue&type=script&lang=ts&"
export * from "./Logs.vue?vue&type=script&lang=ts&"
import style0 from "./Logs.vue?vue&type=style&index=0&id=24e18aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e18aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e18aae')) {
      api.createRecord('24e18aae', component.options)
    } else {
      api.reload('24e18aae', component.options)
    }
    module.hot.accept("./Logs.vue?vue&type=template&id=24e18aae&scoped=true&", function () {
      api.rerender('24e18aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/History/Logs.vue"
export default component.exports